import dayjs from 'dayjs'

export interface ZbMilestoneRender extends API.MilestoneZb.Item {
  cumulativePercent: string
  overdue: boolean
  overdueDays: number
  displayDate: string
}

export const formatZbPercent = (ratio: number) => {
  const percent = ratio * 100
  if (percent === 0) return '0%'
  if (percent < 1) return `${percent.toFixed(2)}%`
  // Avoid displaying 28% for a floating-point sum representing exactly 29%.
  return `${Math.floor(Number(percent.toFixed(8)))}%`
}

export const buildZbMilestones = (data: API.MilestoneZb.Item[], today = dayjs()): ZbMilestoneRender[] => {
  let cumulative = 0
  const startOfToday = today.startOf('day')
  return [...data].sort((a, b) => a.sortOrder - b.sortOrder || a.id - b.id).map(item => {
    cumulative += item.percentage
    const planDate = item.planDate ? dayjs(item.planDate).startOf('day') : null
    const overdue = item.status === 0 && !!planDate && planDate.isBefore(startOfToday)
    return {
      ...item,
      cumulativePercent: formatZbPercent(cumulative),
      overdue,
      overdueDays: overdue ? startOfToday.diff(planDate, 'day') : 0,
      displayDate: item.actualDate || item.planDate || '',
    }
  })
}

export const zbErrorMessage = (error: unknown, fallback: string) =>
  typeof error === 'string' ? error : error instanceof Error ? error.message : fallback
